<template>
    <b-button
        size="lg"
        :variant="variant"
        @click="handleClick"
        class="cta-button"
    >
        {{ action.displayText }}
    </b-button>
</template>

<script>
    import LandingPageActionAppResource,
    {
        SELF_START_HUB,
        INTERNAL_LINK,
        EXTERNAL_LINK,
        HOME_OWNERSHIP,
    }
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageActionAppResource";
    import {INTERSTITIAL_MODAL_TYPES, showInterstitialModal} from "../../../helpers/modals";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";

    export default {
        name: "CTAButton",
        props: {
            landingPage: {
                type: LandingPageAppResource,
                default: () => {
                    return new LandingPageAppResource({});
                }
            },
            action: {
                type: LandingPageActionAppResource,
                required: true
            },
            variant: {
                type: String,
                default: 'primary'
            }
        },
        methods: {
            handleClick() {
                switch (this.action.type) {
                    case SELF_START_HUB:
                        showInterstitialModal(
                            INTERSTITIAL_MODAL_TYPES.GET_STARTED,
                            {
                                firstName: this.landingPage.firstName,
                                lastName: this.landingPage.lastName,
                                displayName: this.landingPage.displayName,
                                avatar: this.landingPage.avatar,
                            },
                            {
                                landingPageUuid: landingPageUuid,
                            }
                        );
                        break;
                    case INTERNAL_LINK:
                        this.$router.push({name: `landing-page.${this.action.destination}`});
                        break;
                    case EXTERNAL_LINK:
                        window.open(this.action.destination, '_blank');
                        break;
                    case HOME_OWNERSHIP:
                        showInterstitialModal(
                            INTERSTITIAL_MODAL_TYPES.HOME_OWNERSHIP,
                            {},
                            {
                                landingPageUuid: landingPageUuid,
                                ...this.action.redirectQueryParams,
                            }
                        );
                }
            }
        }
    };
</script>
